import type { SnapshotFrom } from 'xstate'
import type { schedulerMachine, SchedulerContext } from './machine'

type SchedulerSnapshot = SnapshotFrom<typeof schedulerMachine>

/**
 * Selectors for stable reads from the scheduler state machine snapshot.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const selectSlotId = schedulerSelectors.slotId
 * ```
 */
export const schedulerSelectors = {
  context: (snapshot: SchedulerSnapshot): SchedulerContext => snapshot.context,
  currentState: (snapshot: SchedulerSnapshot) => snapshot.value,
  patient: (snapshot: SchedulerSnapshot) => snapshot.context.patient,
  appointmentTypeId: (snapshot: SchedulerSnapshot) => snapshot.context.appointmentTypeId,
  appointmentTypeName: (snapshot: SchedulerSnapshot) => snapshot.context.appointmentTypeName,
  slotId: (snapshot: SchedulerSnapshot) => snapshot.context.slotId,
  slotCalendarId: (snapshot: SchedulerSnapshot) => snapshot.context.slotCalendarId,
  slotStart: (snapshot: SchedulerSnapshot) => snapshot.context.slotStart,
  appointmentDescription: (snapshot: SchedulerSnapshot) => snapshot.context.appointmentDescription,
  bookingId: (snapshot: SchedulerSnapshot) => snapshot.context.bookingId,
}
